import { render, staticRenderFns } from "./yanghua_tem.vue?vue&type=template&id=db8a4cec&scoped=true&"
import script from "./yanghua_tem.vue?vue&type=script&lang=js&"
export * from "./yanghua_tem.vue?vue&type=script&lang=js&"
import style0 from "./yanghua_tem.vue?vue&type=style&index=0&id=db8a4cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8a4cec",
  null
  
)

export default component.exports